import {registerStyle, styleRule, UI} from "stem-core/src/ui/UI";
import {StyleSheet} from "stem-core/src/ui/Style";
import {Card} from "../../ui/Card";
import {CardItems} from "../../ui/CardItems";
import {AddCreditModal} from "../AddCreditModal";
import {Money} from "../../../../../client/state/misc/Money";
import {BlinkButton} from "../../../../../blinkpay/ui/Button";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {WalletStore} from "../../../../../client/state/WalletStore";

class UserWalletStyle extends StyleSheet {
    @styleRule
    addCreditButton = {
        marginTop: 20,
        fontWeight: "normal",
    };

}

@registerStyle(UserWalletStyle)
@autoredraw(WalletStore)
export class UserWallet extends UI.Element {

    onAddCreditClick() {
         const {user} = this.options;
        // TODO - can have multiple
        const wallet = user.getDefaultWallet();

        AddCreditModal.show({user, wallet});
    }

    render() {
        const {user} = this.options;
        // TODO - can have multiple
        const wallet = user.getDefaultWallet();

        return (
            <Card title="Wallet">
                <CardItems
                    items={[
                        ["Id", wallet.id],
                        ["Currency", wallet.getCurrency().isoCode.toUpperCase()],
                        ["Balance", Money.format(wallet.balance, wallet.getCurrency())],
                    ]}
                />
                <BlinkButton className={this.styleSheet.addCreditButton}
                             onClick={() => this.onAddCreditClick()}
                             label="Add Credit">
                </BlinkButton>
            </Card>
        );
    }
}
